import './splash-screen.css';
import '../../loader.css';
import logo from '../../assets/logo_converted.webp';

const SplashScreen = ({ orientation }) => {
    return (
        <div className="splash-container">
            <div className="splash-centered-box">
                <img src={logo} alt="Logo" className="splash-logo" />
                <div className="loader"></div>
            </div>
        </div>
    )
}

export default SplashScreen;
